import React, {useEffect, useState} from 'react';
import {
    addNewQuestionAtIdx,
    addQuestionToSurveyAtIdx,
    changeQuestionTab,
    changeSurvey,
    isSurveyEditRestrictedSelector,
    removeQuestionFromSurveyAtIdx,
    updateQuestionInSurveyAtIdx,
    validateQuestionAtIndex
} from "../../../../slices/surveyEditorSlice";
import {connect, useDispatch, useSelector} from "react-redux";
import QuestionEditMode from "./edit_mode/QuestionEditMode";
import QuestionViewMode from "./view_mode/QuestionViewMode";
import {
    addUISettingsToSurveyQuestions,
    findNextAvailableQid,
    iconMapByQType,
    questionsEditModeMenuTabs
} from "../../../../utils/SurveyUtils";
import {validateQuestion, validateSurvey} from "../../../../utils/SurveyValidationUtils";
import {duplicateQuestion} from "../../../../utils/SurveyCleanupUtils";
import SurveysService from "../../../../services/SurveysService";
import {withRouter} from "react-router-dom";
import DeleteQuestionModal from "../../modals/DeleteQuestionModal";
import {withToastManager} from "react-toast-notifications";

function QuestionBox(props) {
    const dispatch = useDispatch();

    const [isSurveySaving, setIsSurveySaving] = useState(false);
    const [showMobileActions, setShowMobileActions] = useState(false);
    const [showDeleteQuestionModal, setShowDeleteQuestionModal] = useState(false);
    const surveyEditRestricted = useSelector(isSurveyEditRestrictedSelector);

    const handleToggleShowMobileActions = (event) => {
        setShowMobileActions(!showMobileActions);
    };

    const handleSurveySave = (executeActionAfterSaveSuccess) => {
        let survey = JSON.parse(JSON.stringify(props.survey));

        let isSurveyValid = validateSurvey(survey);
        if (!isSurveyValid) return;

        setIsSurveySaving(true);
        SurveysService.saveSurvey(survey,
            (success1) => {
                if (survey.id) {
                    SurveysService.getSurveyById(survey.id,
                        (success2) => {
                            let freshSurvey = success2.data;
                            addUISettingsToSurveyQuestions(freshSurvey);
                            freshSurvey.defaultQuestions = freshSurvey.questions;
                            dispatch(changeSurvey(freshSurvey));
                            if(executeActionAfterSaveSuccess) {
                                executeActionAfterSaveSuccess();
                            }
                            setIsSurveySaving(false);
                        },
                        (error2) => {
                            props.toastManager.add("Survey refresh after save error!", {
                                appearance: 'error'
                            });
                            setIsSurveySaving(false);
                        });
                } else {
                    let params = "";
                    if(executeActionAfterSaveSuccess && executeActionAfterSaveSuccess.name.localeCompare(initNewQuestionAfterCurrentOne.name) === 0) {
                        params = params + "?addQAfterFirstQuestion=1";
                    }
                    const path = '/survey/builder/' + success1.data + (params ? params : "");
                    props.history.push(path);
                }
            },
            (error1) => {
                props.toastManager.add("Error saving existing edit mode question!", {
                    appearance: 'error'
                });
                setIsSurveySaving(false);
            }
        );
    };

    const isOnlyOneQuestionInSurvey = () =>{
      if(props.survey.questions.length === 1){
          return true;
      }
    };

    const handleEditModeBehavior = (actionType) => {
        const indexQuestionInEditMode = findIndexOfQuestionInEditMode();

        if(isOnlyOneQuestionInSurvey() && (actionType === "QUESTION_DELETE")){
            return;
        }

        if (typeof indexQuestionInEditMode !== 'undefined') {
            let newQuestionData = JSON.parse(JSON.stringify(props.survey.questions[indexQuestionInEditMode]));
            newQuestionData.isInvalidQuestion = !validateQuestion(newQuestionData);
            dispatch(updateQuestionInSurveyAtIdx({idx: indexQuestionInEditMode, questionData: newQuestionData}));

            if(!newQuestionData.isInvalidQuestion) {
                changeEditModeForQuestionAtIndex(indexQuestionInEditMode, false);
                const actionFunction = getFunctionForActionType(actionType);

                handleSurveySave(actionFunction);
            }else{
                dispatch(changeQuestionTab({idx: indexQuestionInEditMode, tab: questionsEditModeMenuTabs[0]}));
                props.scrollIntoViewHandler(indexQuestionInEditMode, "Please fix these errors first and then try again.");
            }
        }
        else {
            const actionFunction = getFunctionForActionType(actionType);
            actionFunction(false);
        }
    };

    const getFunctionForActionType = (actionType) => {
        switch (actionType) {
            case "QUESTION_ADD":
                return initNewQuestionAfterCurrentOne;
            case "QUESTION_DELETE":
                return deleteCurrentQuestion;
            case "QUESTION_DUPLICATE":
                return duplicateCurrentQuestion;
            case "QUESTION_SWITCH_EDIT_MODE":
                return switchCurrentQuestionToEditMode;
            default:
                return () => {};
        }
    };

    const initNewQuestionAfterCurrentOne = () => {
        let availableQId = findNextAvailableQid(props.survey.questions);
        props.addNewQuestionAtIdx(props.idx + 1, availableQId);
        setTimeout(() => {
            scrollToQuestion(props.idx + 1);
        }, 500)
    };

    const scrollToQuestion = (questionIndex) => {
        const questionNode = document.getElementById("question_box_id_" + questionIndex);
        const questionTopDistance = window.pageYOffset + questionNode.getBoundingClientRect().top;
        const moveLocation = questionTopDistance - 90;
        if(typeof questionNode !== 'undefined') {
            window.scrollTo({ behavior: 'smooth', top: moveLocation });
        }
    };

    const findIndexOfQuestionInEditMode  = () => {
        const index = props.survey.questions.findIndex(element => element.editMode === true);
        return index === -1 ? undefined : index;
    };


    const duplicateCurrentQuestion = () => {
        const nextAvailableQid = findNextAvailableQid(props.survey.questions);
        const {question_id, ...cleanedQuestion} = props.survey.questions[props.idx];
        dispatch(addQuestionToSurveyAtIdx({
            insertAtIndex: props.idx + 1,
            questionData: {
                ...duplicateQuestion(cleanedQuestion, nextAvailableQid),
                id: nextAvailableQid,
                editMode: true
            }
        }));
        setTimeout(() => {props.scrollIntoViewHandler(props.idx + 1);}, 500);
    };

    const deleteCurrentQuestion = () => {
        const {idx} = props;
        let survey = JSON.parse(JSON.stringify(props.survey));
        survey.questions.splice(idx, 1);

        SurveysService.saveSurvey(survey,
            (success) => {
                SurveysService.getSurveyById(survey.id,
                    (success2) => {
                        let freshSurvey = success2.data;
                        addUISettingsToSurveyQuestions(freshSurvey);
                        freshSurvey.defaultQuestions = freshSurvey.questions;
                        dispatch(changeSurvey(freshSurvey));
                    },
                    (error2) => {
                        props.toastManager.add("Survey refresh after save error!", {
                            appearance: 'error'
                        });
                    });
            },
            (error) => {
                props.toastManager.add("Survey save error after question removal!", {
                    appearance: 'error'
                });
            }
        );
    };

    const switchCurrentQuestionToEditMode = () => {
        const {idx} = props;
        changeEditModeForQuestionAtIndex(idx, true);
    };

    const getQuestionText = () => {
        let questionText = props.questionData.question && props.questionData.question !== "" ? props.questionData.question : "";
        if(props.questionData.editMode && questionText === "") {
            return "Your question will appear here";
        }
        return questionText;
    };

    const changeEditModeForQuestionAtIndex = (index, editMode) => {
        if(typeof editMode !== "undefined" && typeof index !== 'undefined') {
            const question = props.survey.questions[index];
            let newQuestionData = JSON.parse(JSON.stringify(question));
            newQuestionData.editMode = editMode;
            dispatch(updateQuestionInSurveyAtIdx({idx: index, questionData: newQuestionData}));
        }
    };

    const questionText = getQuestionText();

    const handleDiscard = () => {
        const defaultQuestion = props.survey.defaultQuestions.find(question => question.question_id === props.questionData.question_id);
        if(typeof defaultQuestion === 'undefined'){
            dispatch(removeQuestionFromSurveyAtIdx({idx: props.idx}));
        }else {
            dispatch(updateQuestionInSurveyAtIdx({idx: props.idx, questionData: defaultQuestion}));
        }
    };

    const mobileActionsClassName = (showMobileActions ? "" : " questionaire__builder__question__actions__disabled");

    return (
        <React.Fragment>
            <div id={"question_box_id_" + props.idx}
                className={"questionaire__builder__question " + (!props.questionData.editMode ? " questionaire__builder__question--shadow" : "")}>
                <div
                    className="questionaire__builder__question__title questionaire__builder__question__title--dark" >
                    <span className="questionaire__builder__question__title__number">{props.questionData.id}</span>
                    {props.questionData.type &&
                    (
                        <React.Fragment>
                            <span className={"questionaire__builder__question__title__icon questionaire__builder__question__title__icon--" + (iconMapByQType[props.questionData.type] ? iconMapByQType[props.questionData.type] : "single")}></span>
                            <span className="questionaire__builder__question__title__text ">
                                {questionText}
                            </span>
                        </React.Fragment>
                    )
                    }
                    {!props.questionData.editMode &&
                    (
                        <div className={showMobileActions ? "questionaire__builder__question__actions questionaire__builder__question__actions--active" : "questionaire__builder__question__actions"}>
                            <DeleteQuestionModal
                                modalShown={showDeleteQuestionModal}
                                deleteAction={() => {handleEditModeBehavior("QUESTION_DELETE");setShowDeleteQuestionModal(false)}}
                                closeModal={() => {setShowDeleteQuestionModal(false)}} />
                            <div className="questionaire__builder__question__actions__dots" onClick={handleToggleShowMobileActions}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <a href="#" title="Edit" onClick={(event) => {event.preventDefault();handleEditModeBehavior("QUESTION_SWITCH_EDIT_MODE")}}
                               className={"questionaire__builder__question__actions__edit" + mobileActionsClassName}></a>
                            {
                                !surveyEditRestricted &&
                                <a href="#" title="Reorder" onClick={(event) => {event.preventDefault();}}
                                   className={"questionaire__builder__question__actions__move" + mobileActionsClassName}></a>
                            }
                            <a href="#" title="Duplicate" onClick={(event) => {event.preventDefault();handleEditModeBehavior("QUESTION_DUPLICATE")}}
                               className={"questionaire__builder__question__actions__copy" + mobileActionsClassName}></a>
                            {
                                (props.survey.questions.length > 1 && !surveyEditRestricted) &&
                                <a href="#" title="Delete" onClick={(event) => {event.preventDefault();setShowDeleteQuestionModal(true)}}
                                   className={"questionaire__builder__question__actions__delete" + mobileActionsClassName}></a>
                            }
                        </div>
                    )
                    }
                    {props.questionData.editMode &&
                    (
                        <div className="questionaire__builder__question__actions">
                            <a href="#" onClick={(event) => {event.preventDefault();handleDiscard()}} className="questionaire__builder__question__actions__close"/>
                        </div>
                    )
                    }
                </div>
                {props.questionData.editMode ?
                    (<QuestionEditMode questionData={props.questionData} idx={props.idx} handleSurveySave={handleSurveySave} isSurveySaving={isSurveySaving}/>)
                    :
                    (<QuestionViewMode questionData={props.questionData} idx={props.idx} />)
                }
            </div>
            <a href="#" onClick={(event) => {event.preventDefault();handleEditModeBehavior("QUESTION_ADD");}} className="questionaire__builder__action">+ Add new
                questions here</a>
        </React.Fragment>
    )
}

function mapStateToProps(state) {
    const {survey} = state;
    return {survey};
}

const mapDispatchToProps = {addNewQuestionAtIdx, validateQuestionAtIndex};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withToastManager(QuestionBox)));